export default __webpack_public_path__ + "static/php-master-edited-13d70da25199d39e5b72482c24413486.png";